import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import moment from "moment";
//store
import { getUsers } from "../../Store/users/actions";
import { getArtforms, deleteArtforms } from "../../Store/artform/actions";

// components
import { debounce } from "../../common/commonFiles/debounce";
import Index from "../../common/Components/Index";
import { HeaderData, HeaderDataOrgAdmin } from "./Header";
import QuickFilter from "./QuickFilter";
import notifications from "../../common/Components/Notifications/Notification";
import ViewArtfom from "./ViewArtfom";
import ArtformModal from "./ArtformModal";
import DeleteConfirm from "../../common/Components/DeleteConfirm";
import { isArray } from "lodash";

var offset: any = 0;
var limit: any = 10;
var totPages = 0;
var totCnt: any = 0;
var toVal: any = 0;
var fromVal: any = 0;
// selector options
var creatorOptions: any = [];
const Artform = (props: any) => {
  const [loading, setLoading]: any = useState(false);
  const [openModal, setOpenModal]: any = useState(false);
  const [openViewModal, setOpenViewModal]: any = useState(false);
  const [viewData, setViewData]: any = useState("");
  const [editData, setEditData]: any = useState("");
  const [deleteData, setDeleteData]: any = useState("");
  const [filters, setFilters]: any = useState({
    artform: "",
    creator: "",
  });
  const [filterDateValue, setFilterDateValue]: any = useState(null);
  const [sortName, setSortName]: any = useState({
    name: "",
    order: "",
  });
  const [warningModal, setWarningModal]: any = useState(false);
  let auth: any = localStorage.getItem("authUser");
  let authUser: any = JSON.parse(auth) || "";
  let organizationId =
    authUser?.users?.role === "ORGANIZATION_MANAGER" ||
    authUser?.users?.role === "ORGANIZATION_ADMIN"
      ? authUser?.users?.organizationResponse?._id
      : "";
  const openViewModalPopUp = () => {
    setOpenViewModal(true);
  };
  const openModalPopUp = () => {
    setOpenModal(true);
  };
  const closeModal = () => {
    setOpenModal(false);
    setEditData("");
    setOpenViewModal(false);
    setViewData("");
    getAllData();
  };
  useEffect(() => {
    getAllData();
  }, []);
  useEffect(() => {
    if (sortName?.name?.length > 0) {
      getAllData();
    }
  }, [sortName]);

  useEffect(() => {
    if (filters?.artform?.length) {
      handleChangeDebounce({ ...filters, filterDateValue });
    } else if (filters?.creator?.value) {
      getAllData({
        ...filters,
        filterDateValue,
      });
    }
  }, [filters]);
  useEffect(() => {
    if (filterDateValue?.length > 0) {
      getAllData({ ...filters, filterDateValue });
    }
  }, [filterDateValue]);
  const handleChangeDebounce = React.useCallback(
    debounce((data: any) => {
      getAllData(data);
    }, 1000),
    []
  );
  const getAllData = (filters?: any) => {
    let orderByAsc = sortName?.order === "asc" ? "1" : "";
    let orderByDesc = sortName?.order === "desc" ? "-1" : "";
    let dateValue = filters?.filterDateValue || filterDateValue;
    let startDate =
      dateValue?.length && moment(dateValue[0]).format("YYYY-MM-DD");
    let endDate =
      dateValue?.length && moment(dateValue[1]).format("YYYY-MM-DD");
    setLoading(true);
    props.getArtforms(
      {
        offset: offset,
        limit: limit,
        artformName: filters?.artform,
        startDate: startDate,
        endDate: endDate,
        sortBy: sortName?.name,
        orderBy: orderByAsc || orderByDesc,
        createdBy: filters?.creator?.value,
      },
      () => {
        setLoading(false);
      }
    );
    setEditData("");
  };
  const handleChangeFilter = (type: any) => {
    offset = 0;
    setFilters({
      ...filters,
      [type.name]: type?.value,
    });
  };
  const handlePageChange = (event: any, value: any) => {
    offset = (value - 1) * 1;
    getAllData({
      ...filters,
      offset,
      filterDateValue,
    });
  };
  var data: any = [];
  const deleteDataWithConfirm = (deleteData: any) => {
    props.deleteArtforms(
      {
        artFormId: deleteData?._id,
      },
      (res: any) => {
        if (res.success) {
          notifications({
            title: "Success!",
            message: res?.message,
            type: "success",
          });
          getAllData();
        } else {
          notifications({
            title: "Error!",
            message: res?.message,
            type: "danger",
          });
        }
      }
    );
  };

  if (props.artFormDetails !== undefined) {
    if (
      isArray(props?.artFormDetails?.data?.docs) &&
      props?.artFormDetails?.data?.docs?.length > 0
    ) {
      totCnt = props?.artFormDetails?.data?.length;
      totPages = Math.ceil(totCnt / 10);
      fromVal = totCnt !== 0 ? offset * 10 + 1 : fromVal;
      toVal =
        props?.artFormDetails?.data?.offset * 10 +
        props?.artFormDetails?.data?.docs?.length;
      props?.artFormDetails?.data?.docs.map((ele: any, i: any) => {
        data.push({
          artForm: ele?.name,
          createdBy: ele?.createdBy?.role
            ? ele?.createdBy?.role?.replace("_", " ")
            : "NA",
          createdAt: ele?.createdAt
            ? moment(new Date(ele?.createdAt))
                .subtract(5, "hours")
                .subtract(30, "minutes")
                .format("YYYY-MM-DD LT")
            : "NA",
          actions: (
            <div className="d-flex align-items-center tableBtns">
              <span
                className="btns "
                onClick={() => {
                  setViewData(ele);
                  openViewModalPopUp();
                }}
              >
                View
              </span>
              <span className="actionLineHeight"></span>
              <span
                className="btns ms-2"
                onClick={() => {
                  setEditData(ele);
                  openModalPopUp();
                }}
              >
                Edit
              </span>
              <span className="actionLineHeight"></span>
              &nbsp;&nbsp;
              <span
                className="btns"
                onClick={() => {
                  setDeleteData(ele);
                  setWarningModal(true);
                }}
              >
                Delete
              </span>
            </div>
          ),
        });
      });
    } else {
      totCnt = 0;
      totPages = 0;
    }
  }
  const handleChangeDate = (date: any) => {
    offset = 0;
    setFilterDateValue(date);
  };
  const getCreatorsData = (data?: any) => {
    props.getUsers(
      {
        offset: offset,
        limit: 10,
        organizationId,
        usersName: data?.value,
      },
      (res: any) => {
        creatorOptions = [];
        res?.data?.docs.map((ele: any) => {
          creatorOptions.push({
            label: ele?.name,
            value: ele?._id,
          });
        });
      }
    );
  };

  const handleSort = (data: any) => {
    if (data?.name === "artForm") {
      setSortName({
        name: "artform",
        order: data?.sort,
      });
    } else if (data?.name === "createdAt") {
      setSortName({
        name: "createdAt",
        order: data?.sort,
      });
    } else if (data?.name === "createdBy") {
      setSortName({
        name: "createdBy",
        order: data?.sort,
      });
    }
  };
  const handleKeyDown = (event: any) => {
    if (event.key === "Enter") {
      getAllData();
    }
  };
  const handleResetData = () => {
    setFilters({
      artform: "",
      creator: "",
    });
    setFilterDateValue(null);
    props.getArtforms(
      {
        offset: offset,
        limit: limit,
      },
      () => {
        setLoading(false);
      }
    );
  };
  const autoFocus = (data: any) => {
    if (data?.name === "creator") {
      getCreatorsData();
    }
  };
  const handleChangeDebounceforUsers = React.useCallback(
    debounce((data: any) => {
      if (data?.name === "creator") {
        getCreatorsData(data);
      }
    }, 1000),
    []
  );
  const handleOnInputChange = (type: any) => {
    if (type?.name === "creator") {
      if (type?.value?.length >= 2) {
        handleChangeDebounceforUsers({
          name: type?.name,
          value: type?.value,
        });
      }
      if (type?.value.length === 0) {
        handleChangeDebounceforUsers({
          name: type?.name,
          value: type?.value,
        });
      }
    }
  };
  const warningToggle = () => {
    setWarningModal(false);
  };
  return (
    <>
      {openViewModal && (
        <ViewArtfom
          {...props}
          closeModal={closeModal}
          openModal={openViewModal}
          viewData={viewData}
        />
      )}
      {warningModal && (
        <DeleteConfirm
          {...props}
          warningModal={warningModal}
          warningToggle={warningToggle}
          deleteDataWithConfirm={deleteDataWithConfirm}
          deleteData={deleteData}
          getAllData={getAllData}
          name={"Artform"}
        />
      )}

      <ArtformModal
        {...props}
        openModal={openModal}
        closeModal={closeModal}
        editData={editData}
        getAllData={getAllData}
      />
      <Index
        {...props}
        toolbar={
          <QuickFilter
            {...props}
            openModalPopUp={openModalPopUp}
            handleChangeFilter={handleChangeFilter}
            filters={filters}
            handleChangeDate={handleChangeDate}
            filterDateValue={filterDateValue}
            handleResetData={handleResetData}
            getAllData={getAllData}
            handleKeyDown={handleKeyDown}
            creatorOptions={creatorOptions}
            autoFocus={autoFocus}
            handleOnInputChange={handleOnInputChange}
          />
        }
        data={data}
        headerData={
          authUser?.users?.role === "ORGANIZATION_MANAGER" ||
          authUser?.users?.role === "ORGANIZATION_ADMIN"
            ? HeaderDataOrgAdmin
            : HeaderData
        }
        limit={limit}
        handleChange={handlePageChange}
        offset={offset}
        totPages={totPages}
        loading={loading}
        handleSort={handleSort}
        fromVal={fromVal}
        toVal={toVal}
        totCnt={totCnt}
      />
    </>
  );
};
const mapStateToProps = (state: any) => {
  return {
    ...state,
    artFormDetails: state?.artformReducer?.getArtformDetails,
  };
};
export default connect(mapStateToProps, {
  getArtforms,
  deleteArtforms,
  getUsers,
})(Artform);
